import React from 'react';
import styled from 'styled-components';
import { spaces } from '@99designs/emu/settings';
import { ReactComponent as StarburstIcon } from './starburst.svg';

const SVG = styled.div`
    width: 120px;
    margin: 0 auto ${spaces['3bu']};

    #star {
        transform-box: fill-box;
        animation: starshake 2s linear infinite;
        transform-origin: 50% 50%;
    }

    @keyframes starshake {
        0% {
            transform: rotate(0);
        }
        20% {
            transform: rotate(-5deg);
        }
        40% {
            transform: rotate(5deg);
        }
        60% {
            transform: rotate(-5deg);
        }
        80% {
            transform: rotate(5deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    #burst1 {
        animation: 0.6s colors 2s infinite;
    }

    #burst2 {
        animation: 0.6s colors 1.5s infinite;
    }

    #burst3 {
        animation: 0.6s colors 1s infinite;
    }

    @keyframes colors {
        0% {
            fill: #ffb7d5;
        }
        50% {
            fill: #7784f5;
        }
        100% {
            fill: #22c67b;
        }
    }
`;

export function Starburst() {
    return (
        <SVG>
            <StarburstIcon />
        </SVG>
    );
}
